import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'

const EXAMPLE_HOLDERS = [
  { name: 'Lakeside Distribution', certificate: 'Auto + Cargo', lastSent: 'Oct 14, 2026' },
  { name: 'Ridgeline Leasing', certificate: 'Auto', lastSent: 'Oct 2, 2026' },
  { name: 'Summit Freight Yard', certificate: 'General Liability', lastSent: 'Sep 28, 2026' },
]

/** Example rows styled after the account's certificate holders table, faded so they read as a preview. */
export function CoiHoldersIllustration() {
  return (
    <div aria-hidden="true" className="pointer-events-none relative w-full select-none">
      <Table className="table-fixed text-xs">
        <TableHeader>
          <TableRow>
            <TableHead className="w-[42%] font-semibold">Name</TableHead>
            <TableHead className="font-semibold">Certificate</TableHead>
            <TableHead className="font-semibold">Last sent</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {EXAMPLE_HOLDERS.map((holder) => (
            <TableRow key={holder.name}>
              <TableCell className="truncate font-medium">{holder.name}</TableCell>
              <TableCell className="truncate">{holder.certificate}</TableCell>
              <TableCell className="truncate">{holder.lastSent}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <div className="from-card/30 via-card/70 to-card absolute inset-0 bg-linear-to-b" />
    </div>
  )
}
